import { usePageTitle } from '@btime/react-hooks'
import React from 'react'

import { usePermalinkNavigation } from '../../../../utils/routes/permalinkNavigation'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import PageHeaderPanel from '../../../../components/presentation/PageHeaderPanel'
import TemplateRecordPdfPrintButton from '../../../../containers/templateRecords/TemplateRecordPdfPrintButton'

const PageHeader = ({ templateId }) => {
  const serviceOrder = useServiceOrder()
  const navigate = usePermalinkNavigation()

  const getTitle = templateId => {
    if (templateId === 1) {
      return 'Proposta Comercial'
    }
    if (templateId === 2) {
      return 'BIS'
    }
    if (templateId === 3) {
      return 'CII'
    }
    if (templateId === 4) {
      return 'Proforma'
    }
    if (templateId === 5) {
      return 'Formulário Banco do Brasil'
    }
  }

  const title = getTitle(templateId)
  usePageTitle(title)

  return (
    <PageHeaderPanel
      leftIcon="BsArrowLeftShort"
      leftAction={() => navigate(`/service-orders/${serviceOrder.id}/resume`)}
      title={title}
      mediumPadding
      noContainer
      side={<TemplateRecordPdfPrintButton name={title} recordId={serviceOrder?.id} templateId={templateId} />}
    />
  )
}

export default PageHeader
